/* Charge le widget Tally pour les iframes data-tally-src (hauteur dynamique). */
(function () {
  var src = 'https://tally.so/widgets/embed.js';
  function load() {
    if (typeof Tally !== 'undefined') {
      Tally.loadEmbeds();
    } else {
      document.querySelectorAll('iframe[data-tally-src]:not([src])').forEach(function (f) {
        f.src = f.dataset.tallySrc;
      });
    }
  }
  /* Événements du formulaire (formEventsForwarding=1) : Tally les envoie à la page
     par postMessage. On les pousse dans window.dataLayer (Google Tag Manager / GA4)
     et on émet un événement DOM « tally:event » pour tout autre outil. */
  window.addEventListener('message', function (e) {
    if (typeof e.data !== 'string' || e.data.indexOf('Tally.') === -1) return;
    var payload;
    try { payload = JSON.parse(e.data); } catch (err) { return; }
    if (!payload || !payload.event || String(payload.event).indexOf('Tally.') !== 0) return;
    var name = 'tally_' + payload.event.replace('Tally.', '').replace(/([a-z])([A-Z])/g, '$1_$2').toLowerCase();
    var detail = { event: name, tally_event: payload.event, tally_form_id: payload.payload && payload.payload.formId, tally_form_name: payload.payload && payload.payload.formName, tally_page: location.pathname };
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(detail);
    document.dispatchEvent(new CustomEvent('tally:event', { detail: detail }));
  });
  if (typeof Tally !== 'undefined') return load();
  if (document.querySelector('script[src="' + src + '"]')) return load();
  var s = document.createElement('script');
  s.src = src;
  s.onload = load;
  s.onerror = load;
  document.body.appendChild(s);
})();
